/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetSavedPaymentMethodRequestType } from './GetSavedPaymentMethodRequestType';
import {
    GetSavedPaymentMethodRequestTypeFromJSON,
    GetSavedPaymentMethodRequestTypeFromJSONTyped,
    GetSavedPaymentMethodRequestTypeToJSON,
    GetSavedPaymentMethodRequestTypeToJSONTyped,
} from './GetSavedPaymentMethodRequestType';

/**
 * 
 * @export
 * @interface GetSavedPaymentMethodRequest
 */
export interface GetSavedPaymentMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof GetSavedPaymentMethodRequest
     */
    legalEntityId: string;
    /**
     * 
     * @type {GetSavedPaymentMethodRequestType}
     * @memberof GetSavedPaymentMethodRequest
     */
    type?: GetSavedPaymentMethodRequestType;
}

/**
 * Check if a given object implements the GetSavedPaymentMethodRequest interface.
 */
export function instanceOfGetSavedPaymentMethodRequest(value: object): value is GetSavedPaymentMethodRequest {
    if (!('legalEntityId' in value) || value['legalEntityId'] === undefined) return false;
    return true;
}

export function GetSavedPaymentMethodRequestFromJSON(json: any): GetSavedPaymentMethodRequest {
    return GetSavedPaymentMethodRequestFromJSONTyped(json, false);
}

export function GetSavedPaymentMethodRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSavedPaymentMethodRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'legalEntityId': json['legalEntityId'],
        'type': json['type'] == null ? undefined : GetSavedPaymentMethodRequestTypeFromJSON(json['type']),
    };
}

export function GetSavedPaymentMethodRequestToJSON(json: any): GetSavedPaymentMethodRequest {
    return GetSavedPaymentMethodRequestToJSONTyped(json, false);
}

export function GetSavedPaymentMethodRequestToJSONTyped(value?: GetSavedPaymentMethodRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'legalEntityId': value['legalEntityId'],
        'type': GetSavedPaymentMethodRequestTypeToJSON(value['type']),
    };
}

